import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import './ProductOption.module.css';

class ProductOption extends Component {
  constructor(props) {
    super(props);
    const { option } = props;

    const selectedItems = new Map();
    const defaultItem = option.product_links.find(item => item.is_default);
    if (defaultItem) {
      selectedItems.set(defaultItem.sku, defaultItem);
    }

    this.state = {
      selectedItems
    };

    this.changeCallback();
  }

  changeCallback = () => {
    if (this.props.onOptionChange) {
      this.props.onOptionChange(
        this.props.option.option_id,
        this.state.selectedItems
      );
    }
  };

  handleCheckbox = event => {
    const name = event.target.name;
    this.setState(state => {
      const { selectedItems } = state;
      if (selectedItems.has(name)) {
        selectedItems.delete(name);
      } else {
        selectedItems.set(name, this.pickProduct(name));
      }
      return { selectedItems };
    }, this.changeCallback);
  };

  handleRadio = event => {
    const name = event.target.value;
    this.setState(
      state => ({
        selectedItems: new Map([[name, this.pickProduct(name)]])
      }),
      this.changeCallback
    );
  };

  handleReset = event => {
    this.setState(
      state => ({
        selectedItems: new Map()
      }),
      this.changeCallback
    );
  };

  pickProduct = sku => {
    const {
      option: { product_links: links }
    } = this.props;
    return links.find(link => link.sku === sku);
  };

  render() {
    const { option, priceFormatter, t } = this.props;
    const { selectedItems } = this.state;

    const type =
      option.type === 'checkbox' || option.type === 'multi'
        ? 'checkbox'
        : 'radio';

    const nonePrice = Array.from(selectedItems.values()).reduce(
      (price, entry) => price + entry.price,
      0
    );

    // account for instances like the form 3 complete bundle where the base price is zero
    let basePrice = 0;
    // check if there's a default option, if so figure out base price.
    if (option.product_links.some(product => product.is_default)) {
      basePrice = option.product_links
        .filter(link => link.is_default)
        .reduce(
          (min, product) => (product.price < min ? product.product.price : min),
          option.product_links[0].price
        );
    }

    return (
      <ul styleName="list">
        {!option.required && (
          <li styleName="item">
            <label>
              <input
                type={type}
                name="none"
                value={''}
                onChange={this.handleReset}
                checked={selectedItems.size === 0}
              />
              <div>
                <span>{t('None')}</span>
                <span styleName="price">
                  {nonePrice > 0 && `- ${priceFormatter(nonePrice)}`}
                </span>
              </div>
            </label>
          </li>
        )}
        {option.product_links.map(product => {
          const { is_default, name, price, sku } = product;

          const inputName = type === 'checkbox' ? sku : option.option_id;

          // dont display price for options that dont change the total
          const hidePrice =
            (option.type === 'radio' && option.required) ||
            (option.type === 'select' && option.required && is_default);
          return (
            <li key={sku} styleName="item">
              <label>
                <input
                  type={type}
                  name={inputName}
                  value={sku}
                  onChange={
                    type === 'checkbox' ? this.handleCheckbox : this.handleRadio
                  }
                  checked={selectedItems.has(sku)}
                />
                <div>
                  <span>{name || sku}</span>
                  {!hidePrice ? (
                    <span styleName="price">
                      + {priceFormatter(price - basePrice)}
                    </span>
                  ) : null}
                </div>
              </label>
            </li>
          );
        })}
      </ul>
    );
  }
}

ProductOption.propTypes = {
  option: PropTypes.object.isRequired,
  onOptionChange: PropTypes.func
};

export default withTranslation()(ProductOption);
